import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { capgeminiTheme } from '../../theme/capgeminiTheme';

const capgeminiThemeExtension = ThemeBlueprint.make({
  params: {
    theme: {
      id: 'capgemini',
      title: 'Capgemini',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={capgeminiTheme} children={children} />
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [capgeminiThemeExtension],
});
